<lyceo-ui-more-menu
  contentId="main-content"
  *transloco="let t"
  (closeMenu)="close()"
>
  <lyceo-ui-more-menu-item
    (click)="feedback()"
    data-testid="feedback-more-menu-item"
  >
    <fa-icon [icon]="faMessageExclamation" />
    {{ t('menu.feedback') }}
  </lyceo-ui-more-menu-item>
  <lyceo-ui-more-menu-item
    [link]="['https://www.homi.nu/privacybeleid/']"
    [externalLink]="true"
  >
    <fa-icon [icon]="faFileShield" />
    {{ t('menu.privacy_policy') }}
  </lyceo-ui-more-menu-item>
  <lyceo-ui-more-menu-item [link]="['/settings']" (click)="close()">
    <fa-icon [icon]="faGear" />
    {{ t('menu.settings') }}
  </lyceo-ui-more-menu-item>
  @if (this.platformString !== 'web') {
    <lyceo-ui-more-menu-item
      (click)="websiteLogout()"
      data-testid="website-more-menu-item"
    >
      <fa-icon [icon]="faArrowRightFromBracket" />
      {{ t('menu.website_logout') }}
    </lyceo-ui-more-menu-item>
  }
  <lyceo-ui-more-menu-item
    (click)="logout()"
    data-testid="logout-more-menu-item"
  >
    <fa-icon [icon]="faArrowRightFromBracket" />
    {{ t('menu.logout') }}
  </lyceo-ui-more-menu-item>
  <lyceo-ui-more-menu-note data-testid="more-menu-note">
    {{ t('menu.homi_version') }} {{ release }} ({{ platformString }})
  </lyceo-ui-more-menu-note>
</lyceo-ui-more-menu>
